import { StatsProps } from 'types/stats';
import { Icon } from '../icons';
import { type IconKeys } from '../icons/types';
import { StatsCard } from '../stats-card';
import { ViewOnce } from '../view-once';

import './stats-bar.scss';

type Statistics = StatsProps & {
  icon: IconKeys;
};

type StatsBarProps = {
  statistics: Statistics[];
  onView?: () => void;
};

export const StatsBar = ({ statistics, onView }: StatsBarProps) => (
  <ViewOnce onView={onView}>
    <section className="stats-bar-list">
      {statistics.map((stats, index) => {
        const className = index > 0 ? 'hide-on-mobile' : '';

        return (
          <div className={`item ${className}`} key={stats.title}>
            <StatsCard
              title={stats.title}
              value={stats.value}
              icon={
                <Icon
                  type={stats.icon}
                  svgProps={{ width: '100%', height: '100%' }}
                />
              }
              className={className}
              variant="highlighted-title"
            />
          </div>
        );
      })}
    </section>
  </ViewOnce>
);
